
import React, { useEffect, useState } from 'react';
import { TextField, FormControl, InputLabel, Select, MenuItem, Grid, Paper, useMediaQuery, Button, FormHelperText } from '@mui/material';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { TransportMaster } from '../TitleList';
import { useDispatch, useSelector } from 'react-redux';
import { createTransportEntry } from '../../Store/PHPSlice/Transport';
import TransportTable from '../MasterTables/TransportTbl/TransportTable';
import { errorStyles } from '../../Utils/table';


const TransportEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        transportNm: '',
        contact: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const dispatch = useDispatch();
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        // Handle numerical inputs for contactNo and accNo
        if (name === 'contact') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }

        // Ensure contactNo is only 10 digits
        if (name === 'contact' && value.length > 10) {
            return;
        }
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.transportNm) newErrors.transportNm = 'School Name is required';
        if (!formData.contact) newErrors.contact = 'Contact No is required';
        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        dispatch(createTransportEntry(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Transport Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };






    return (
        <>
            <Titlebar data={TransportMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Transport Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={0.5}>

                                {[
                                    { label: 'Transport Name', name: 'transportNm' },
                                    { label: 'Contact', name: 'contact' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '35%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth error={!!errors[field.name]}>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                    {errors[field.name] && <FormHelperText style={errorStyles}>{errors[field.name]}</FormHelperText>}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
                <TransportTable />

            </div>
        </>
    );
}

export default TransportEntry;
